export const AUTH_STORAGE_KEY = 'renaissance:auth:tokens'

export const NEW_URL_CONTROLLING_STATUS = 1500

export const UNQUEUED_URL_CONTROLLING_STATUS = 0

export const DELETE_PRODUCT_SAFE_LIMIT = 250

export const DELETE_COMPETITOR_SAFE_LIMIT = 250

// SmartPrice status codes for which the backend actually reprices the product.
// Mirrors repriceWithSmartPrice() in the backend (SP_NO_ERROR, SP_COST_ZERO).
export const SP_NO_ERROR = -99

export const SP_COST_ZERO = -3

export const REPRICEABLE_SP_STATUSES = [SP_NO_ERROR, SP_COST_ZERO]
